import React from "react";

const NotFound : React.FC= () => {
  return (
      <>
          <div style={{ textAlign: "center" }} className="m-xsmall-top-2">
              {/* <IconExclamationCircle modifiers="app-quick-search__error-icon" /> */}
              <div className="m-xsmall-top-1">Oops!... Sorry, we were not able to find what you were looking for.</div>
          </div>
      </>
  );
};


export default NotFound;